import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/Footer.css";


function Footer() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footerData = useSelector((state) => state.footer?.data || {});

  const {
    restaurantId,
    tableId,
  } = useParams();


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  useEffect(() => {
    if (restaurantId) {
      dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
    }
  }, [dispatch, restaurantId]);

  const restaurantName = footerData.restaurant_name || "Restaurant";
  const description = footerData.description || "";
  const address = footerData.address || "";
  const phone = footerData.phone || "";
  const email = footerData.email || "";
  const openingHours = footerData.opening_hours || "";

  // =====================================================
  // SCROLL TO SECTION
  // =====================================================

  const goToSection = (
    sectionId
  ) => {

    if (
      window.location.pathname ===
      homePath
    ) {

      const element =
        document.getElementById(
          sectionId
        );


      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;

    }


    navigate(homePath);


    setTimeout(() => {

      const element =
        document.getElementById(
          sectionId
        );


      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

    }, 500);

  };


  // =====================================================
  // HOME
  // =====================================================

  const handleHome = () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  };


  // =====================================================
  // MENU
  // =====================================================

  const handleMenu = () => {

    goToSection(
      "t7-menu"
    );

  };


  // =====================================================
  // ABOUT
  // =====================================================

  const handleAbout = () => {

    goToSection(
      "t7-why"
    );

  };


  // =====================================================
  // GALLERY
  // =====================================================

  const handleGallery = () => {

    goToSection(
      "t7-gallery"
    );

  };


  // =====================================================
  // CONTACT
  // =====================================================

  const handleContact = () => {

    goToSection(
      "t7-footer-contact"
    );

  };


  return (

    <footer className="t7-footer">


      {/* =================================================
          TOP DECORATIVE LINE
      ================================================= */}

      <div className="t7-footer-ornament">

        <span></span>

        <b>
          ❋
        </b>

        <span></span>

      </div>



      {/* =================================================
          MAIN FOOTER
      ================================================= */}

      <div className="t7-footer-main">


        <div className="t7-footer-container">


          {/* =================================================
              BRAND
          ================================================= */}

          <div className="t7-footer-brand">

            <button
              type="button"
              className="t7-footer-logo"
              onClick={
                handleHome
              }
            >

              <span>
                {restaurantName}
              </span>

            </button>


            <div className="t7-footer-subtitle">
              INDIAN CUISINE
            </div>


            <p>
              {description}
            </p>


            <div className="t7-footer-table">

              TABLE

              <strong>
                {tableId}
              </strong>

            </div>

          </div>



          {/* =================================================
              EXPLORE
          ================================================= */}

          <div className="t7-footer-column">

            <h3>
              Explore
            </h3>


            <button
              type="button"
              onClick={
                handleHome
              }
            >
              Home
            </button>


            <button
              type="button"
              onClick={
                handleMenu
              }
            >
              Our Menu
            </button>


            <button
              type="button"
              onClick={
                handleAbout
              }
            >
              About Us
            </button>


            <button
              type="button"
              onClick={
                handleGallery
              }
            >
              Gallery
            </button>

          </div>



          {/* =================================================
              VISIT US
          ================================================= */}

          <div
            id="t7-footer-contact"
            className="t7-footer-column"
          >

            <h3>
              Visit Us
            </h3>


            <p>{restaurantName}</p>
            {address && <p>{address}</p>}
            {phone && <p><a href={`tel:${phone}`}>{phone}</a></p>}
            {email && <p><a href={`mailto:${email}`}>{email}</a></p>}

          </div>



          {/* =================================================
              OPENING HOURS
          ================================================= */}

          <div className="t7-footer-column">

            <h3>
              Opening Hours
            </h3>


            {openingHours && (
              <div className="t7-footer-hours">
                <span style={{ whiteSpace: "pre-line" }}>{openingHours}</span>
              </div>
            )}

            <button
              type="button"
              className="t7-footer-order"
              onClick={
                handleMenu
              }
            >
              Order From Menu
              <span>
                →
              </span>
            </button>

          </div>


        </div>

      </div>



      {/* =================================================
          BOTTOM BAR
      ================================================= */}

      <div className="t7-footer-bottom">

        <div className="t7-footer-bottom-inner">

          <span>
            © {new Date().getFullYear()}
            {" "}
            {restaurantName}.
            All rights reserved.
          </span>


          <span>
            Food images are for presentation purposes only. Actual items may vary.
          </span>

          <span>
            Crafted with care
            {" "}
            <b>✦</b>
            {" "}
            for every table.
          </span>

        </div>

      </div>


    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footerData[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>

  );

}


export default Footer;